import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    screen_uiid: "", screen_name: "", location: "", building: "", floor: "", room: "", tags: [], thumbnail_name: "", banner_Visibility: 0, screen_status: "", appInfo: {}, storageInfo: {}
};

const editScreenDataSlice = createSlice({
    name: "editScreenData",
    initialState,
    reducers: {
        getEditScreenData: (state, action) => {
            const { screen_uiid, ic_screen_name, ic_location, ic_building, ic_floor, ic_room, ic_tags, ic_thumbnail_name, ic_hide_banner, ic_screen_status, ic_hide_playlist_progress_bar, ic_hide_dashboard_boiler_plate } = action.payload;
            const thumbnailDisplayName = ic_thumbnail_name?.replace(/^thumbnails_/, "");
            const bannerStatus = ic_hide_banner === 0 ? true : false;
            const progressBarStatus = ic_hide_playlist_progress_bar === 0 ? true : false;
            const dashboardBoilerPlateStatus = ic_hide_dashboard_boiler_plate === 0 ? true : false;

            return {
                ...state, screen_uiid: screen_uiid, screen_name: ic_screen_name, location: ic_location, building: ic_building,
                floor: ic_floor, room: ic_room, tags: ic_tags, thumbnail_name: thumbnailDisplayName, banner_Visibility: bannerStatus, screen_status: ic_screen_status,
                progressbar_visibility: progressBarStatus, dashboard_boilerplate_visibility: dashboardBoilerPlateStatus
            };
        },
        getAppData: (state, action) => {
            const { alert1, alert2 } = action.payload;

            return { ...state, appInfo: alert1, storageInfo: alert2 };
        },
    },
});

export const { getEditScreenData, getAppData } = editScreenDataSlice.actions;

export default editScreenDataSlice.reducer;
